export const interceptLocalStorageClear = () => {
  // keep a reference to the original
  const originalClear = Storage.prototype.clear;

  Object.defineProperty(Storage.prototype, "clear", {
    configurable: true,
    writable:   true,
    value: function() {
      // only intercept localStorage, leave sessionStorage alone
      if (this !== window.localStorage) {
        return originalClear.apply(this);
      }

      const exemptKeys = new Set(["backgroundImg", "logo", "backgroundColor", "nav_bar_color", "nav_bar_font"]);

      // snapshot all keys first, because removing items while iterating
      // will shift indices
      const keys = [];
      for (let i = 0; i < this.length; i++) {
        keys.push(this.key(i));
      }

      // remove everything except the exempted ones
      keys.forEach((key) => {
        if (!exemptKeys.has(key)) {
          this.removeItem(key);
        }
      });

      // if you really want to clear the exempted keys too, call the original:
      // originalClear.call(this);
    },
  });
};
